module.exports = __webpack_public_path__ + "static/media/mn.42fcfde0.svg";